import React from "react";
import { useParams } from "react-router-dom";
import {
  FaDatabase,
  FaFilter,
  FaSearch,
  FaBullhorn,
  FaProjectDiagram,
} from "react-icons/fa";
import card2Bg from "../../../assets/Bulk/Card2/card2.svg";
import card3Bg from "../../../assets/Bulk/Card2/card3.svg";
import Line from "../../../assets/line2.svg";
import {
  CheckCircle,
  AlertTriangle,
  FileText,
  CreditCard,
  FileCheck,
  FileX,
  PieChart,
} from "lucide-react";

const ThreeSections = () => {
  const { topic } = useParams();

  const formattedTopic = topic
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

  const getDescriptionForAdditionalInsights = (topic) => {
    const normalizedTopic = topic.toLowerCase();
    switch (normalizedTopic) {
      case "email_hunter":
        return (
          <div className="grid mt-5 pb-10 gap-6 py-6 min-[950px]:grid-cols-2 p-6">
            <div
              className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left"
              style={{
                backgroundImage: `url(${card3Bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-white opacity-5"></div>
              <div className="relative z-10 flex flex-col h-full">
                <div className="my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 border-[#99E1ED] border bg-[#EBFBFC]">
                  <FaSearch className="text-[#39C4DC] text-xl" />
                </div>
                <h3 className="text-xl font-semibold mb-2">Search Precision</h3>
                <p className="text-gray-600 mb-4">
                  By focusing on Company Names rather than domains, we ensure
                  greater accuracy and overcome platform limitations like those
                  found on LinkedIn.
                </p>
              </div>
            </div>

            <div
              className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left"
              style={{
                backgroundImage: `url(${card2Bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-white opacity-5"></div>
              <div className="relative z-10 flex flex-col h-full">
                <div className="my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 border-[#F9AFBB] border bg-[#FDEBED]">
                  <FaDatabase className="text-[#F88DA0] text-xl" />
                </div>
                <h3 className="text-xl font-semibold mb-2">
                  Comprehensive Data
                </h3>
                <p className="text-gray-600 mb-4">
                  Leveraging LinkedIn Sales filters, we gathered data on
                  "Headcount" and "Location" to create an in-depth comparison.
                </p>
              </div>
            </div>
          </div>
        );
      case "anymail_finder":
        return (
          <></>
        );
      case "prospio":
        return (
          <div className="grid mt-5 pb-10 gap-6 py-6 min-[950px]:grid-cols-2 p-6">
            <div
              className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left"
              style={{
                backgroundImage: `url(${card3Bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-white opacity-5"></div>
              <div className="relative z-10 flex flex-col h-full">
                <div className="my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 border-[#99E1ED] border bg-[#EBFBFC]">
                  <FaSearch className="text-[#39C4DC] text-xl" />
                </div>
                <h3 className="text-xl font-semibold mb-2">Precision Focus</h3>
                <p className="text-gray-600 mb-4">
                  We focus on names instead of websites to overcome
                  accessibility challenges and improve precision on platforms
                  like LinkedIn.
                </p>
              </div>
            </div>

            <div
              className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left"
              style={{
                backgroundImage: `url(${card2Bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-white opacity-5"></div>
              <div className="relative z-10 flex flex-col h-full">
                <div className="my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 border-[#F9AFBB] border bg-[#FDEBED]">
                  <FaFilter className="text-[#F88DA0] text-xl" />
                </div>
                <h3 className="text-xl font-semibold mb-2">Custom Filters</h3>
                <p className="text-gray-600 mb-4">
                  Filters like "Location" and "Headcount" enable precise
                  targeting and comparison.
                </p>
              </div>
            </div>
          </div>
        );
      case "findyemail":
        return (
          <div className="grid mt-5 pb-10 gap-6 py-6 min-[950px]:grid-cols-2 p-6">
            <div
              className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left"
              style={{
                backgroundImage: `url(${card3Bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-white opacity-5"></div>
              <div className="relative z-10 flex flex-col h-full">
                <div className="my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 border-[#99E1ED] border bg-[#EBFBFC]">
                  <FaSearch className="text-[#39C4DC] text-xl" />
                </div>
                <h3 className="text-xl font-semibold mb-2">
                  Enhanced Accuracy
                </h3>
                <p className="text-gray-600 mb-4">
                  Emphasizing names over websites, we overcome challenges and
                  deliver refined search results.
                </p>
              </div>
            </div>

            <div
              className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left"
              style={{
                backgroundImage: `url(${card2Bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-white opacity-5"></div>
              <div className="relative z-10 flex flex-col h-full">
                <div className="my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 border-[#F9AFBB] border bg-[#FDEBED]">
                  <FaFilter className="text-[#F88DA0] text-xl" />
                </div>
                <h3 className="text-xl font-semibold mb-2">
                  Streamlined Filters
                </h3>
                <p className="text-gray-600 mb-4">
                  LinkedIn Sales filters like "Headcount" and "Location"
                  streamline data collection for optimal comparisons.
                </p>
              </div>
            </div>
          </div>
        );
      case "get_prospect":
        return (
          <div className="grid mt-5 pb-10 gap-6 py-6 min-[950px]:grid-cols-2 p-6">
            <div
              className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left"
              style={{
                backgroundImage: `url(${card3Bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-white opacity-5"></div>
              <div className="relative z-10 flex flex-col h-full">
                <div className="my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 border-[#99E1ED] border bg-[#EBFBFC]">
                  <FaSearch className="text-[#39C4DC] text-xl" />
                </div>
                <h3 className="text-xl font-semibold mb-2">
                  Enhanced Accuracy
                </h3>
                <p className="text-gray-600 mb-4">
                  Prioritizing business names, we deliver superior accuracy by
                  overcoming common platform constraints.
                </p>
              </div>
            </div>

            <div
              className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left"
              style={{
                backgroundImage: `url(${card2Bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-white opacity-5"></div>
              <div className="relative z-10 flex flex-col h-full">
                <div className="my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 border-[#F9AFBB] border bg-[#FDEBED]">
                  <FaFilter className="text-[#F88DA0] text-xl" />
                </div>
                <h3 className="text-xl font-semibold mb-2">Refined Filters</h3>
                <p className="text-gray-600 mb-4">
                  Using LinkedIn Sales filters, such as "Headcount" and
                  "Location," ensures detailed and relevant data comparisons.
                </p>
              </div>
            </div>
          </div>
        );
      default:
        return (
          <div className="grid mt-5 pb-10 gap-6 py-6 min-[950px]:grid-cols-2 p-6">
            <div className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left">
              <h3 className="text-xl font-semibold mb-2">General Insights</h3>
              <p className="text-gray-600 mb-4">
                Explore our refined methods for accurate data collection and
                insightful comparisons.
              </p>
            </div>
          </div>
        );
    }
  };

  const getDescriptionForEmailQuality = (topic) => {
    const normalizedTopic = topic.toLowerCase();
    switch (normalizedTopic) {
      case "email_hunter":
        return (
          <div className="grid mt-5 pb-10 gap-6 py-6 min-[950px]:grid-cols-2 p-6">
            <div
              className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left"
              style={{
                backgroundImage: `url(${card3Bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-white opacity-5"></div>
              <div className="relative z-10 flex flex-col h-full">
                <div className="my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 border-[#99E1ED] border bg-[#EBFBFC]">
                  <FaBullhorn className="text-[#39C4DC] text-xl" />
                </div>
                <h3 className="text-xl font-semibold mb-2">
                  Premium Verified Emails
                </h3>
                <p className="text-gray-600 mb-4">
                  With Exact Mails, you get 1,000 verified emails with a 97%+
                  deliverability rate. Plus, catch-all types and additional
                  verified emails are included at no extra cost.
                </p>
              </div>
            </div>

            <div
              className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left"
              style={{
                backgroundImage: `url(${card2Bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-white opacity-5"></div>
              <div className="relative z-10 flex flex-col h-full">
                <div className="my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 border-[#F9AFBB] border bg-[#FDEBED]">
                  <FaProjectDiagram className="text-[#F88DA0] text-xl" />
                </div>
                <h3 className="text-xl font-semibold mb-2">
                  Mixed-Quality Emails
                </h3>
                <p className="text-gray-600 mb-4">
                  With {formattedTopic}, you get 500 mixed-quality emails,
                  including invalid, disposable, and low-quality addresses,
                  leading to lower engagement and wasted resources.
                </p>
              </div>
            </div>
          </div>
        );
      case "anymail_finder":
        return <></>;
      case "prospio":
        return (
          <div className="grid mt-5 pb-10 gap-6 py-6 min-[950px]:grid-cols-2 p-6">
            <div
              className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left"
              style={{
                backgroundImage: `url(${card3Bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-white opacity-5"></div>
              <div className="relative z-10 flex flex-col h-full">
                <div className="my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 border-[#99E1ED] border bg-[#EBFBFC]">
                  <FaBullhorn className="text-[#39C4DC] text-xl" />
                </div>
                <h3 className="text-xl font-semibold mb-2">
                  Premium Verified Emails
                </h3>
                <p className="text-gray-600 mb-4">
                  With Exact Mails, you get 1,000 high-quality verified emails
                  with a 97%+ deliverability rate, and catch-all types are
                  included at no additional cost.
                </p>
              </div>
            </div>

            <div
              className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left"
              style={{
                backgroundImage: `url(${card2Bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-white opacity-5"></div>
              <div className="relative z-10 flex flex-col h-full">
                <div className="my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 border-[#F9AFBB] border bg-[#FDEBED]">
                  <FaProjectDiagram className="text-[#F88DA0] text-xl" />
                </div>
                <h3 className="text-xl font-semibold mb-2">
                  Unverified or Invalid Emails
                </h3>
                <p className="text-gray-600 mb-4">
                  With {formattedTopic}, you receive 500 emails that may contain
                  unverified or invalid addresses, resulting in wasted time and
                  potentially damaging your sender reputation.
                </p>
              </div>
            </div>
          </div>
        );
      case "get_prospect":
        return (
          <div className="grid mt-5 pb-10 gap-6 py-6 min-[950px]:grid-cols-2 p-6">
            <div
              className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left"
              style={{
                backgroundImage: `url(${card3Bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-white opacity-5"></div>
              <div className="relative z-10 flex flex-col h-full">
                <div className="my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 border-[#99E1ED] border bg-[#EBFBFC]">
                  <FaBullhorn className="text-[#39C4DC] text-xl" />
                </div>
                <h3 className="text-xl font-semibold mb-2">
                  High-Quality Verified Emails
                </h3>
                <p className="text-gray-600 mb-4">
                  With Exact Mails, you receive 1,000 verified emails with a
                  97%+ deliverability rate, plus catch-all emails at no extra
                  cost.
                </p>
              </div>
            </div>

            <div
              className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left"
              style={{
                backgroundImage: `url(${card2Bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-white opacity-5"></div>
              <div className="relative z-10 flex flex-col h-full">
                <div className="my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 border-[#F9AFBB] border bg-[#FDEBED]">
                  <FaProjectDiagram className="text-[#F88DA0] text-xl" />
                </div>
                <h3 className="text-xl font-semibold mb-2">
                  Risk of Invalid Emails
                </h3>
                <p className="text-gray-600 mb-4">
                  With {formattedTopic}, you get 500 emails that may include
                  invalid, disposable, or low-quality emails, potentially
                  reducing engagement and increasing bounce rates.
                </p>
              </div>
            </div>
          </div>
        );
      case "findyemail":
        return (
          <div className="grid mt-5 pb-10 gap-6 py-6 min-[950px]:grid-cols-2 p-6">
            <div
              className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left"
              style={{
                backgroundImage: `url(${card3Bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-white opacity-5"></div>
              <div className="relative z-10 flex flex-col h-full">
                <div className="my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 border-[#99E1ED] border bg-[#EBFBFC]">
                  <FaBullhorn className="text-[#39C4DC] text-xl" />
                </div>
                <h3 className="text-xl font-semibold mb-2">
                  Reliable Verified Emails
                </h3>
                <p className="text-gray-600 mb-4">
                  With Exact Mails, you receive 1,000 verified emails with a
                  97%+ deliverability rate, including catch-all emails at no
                  extra cost.
                </p>
              </div>
            </div>

            <div
              className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left"
              style={{
                backgroundImage: `url(${card2Bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-white opacity-5"></div>
              <div className="relative z-10 flex flex-col h-full">
                <div className="my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 border-[#F9AFBB] border bg-[#FDEBED]">
                  <FaProjectDiagram className="text-[#F88DA0] text-xl" />
                </div>
                <h3 className="text-xl font-semibold mb-2">
                  Mixed-Quality Email Lists
                </h3>
                <p className="text-gray-600 mb-4">
                  With {formattedTopic}, you get 500 emails that may include
                  invalid, disposable, and low-quality emails, leading to wasted
                  time and effort.
                </p>
              </div>
            </div>
          </div>
        );
      default:
        return (
          <div className="grid mt-5 pb-10 gap-6 py-6 min-[950px]:grid-cols-2 p-6">
            <div
              className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left"
              style={{
                backgroundImage: `url(${card3Bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-white opacity-5"></div>
              <div className="relative z-10 flex flex-col h-full">
                <div className="my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 border-[#99E1ED] border bg-[#EBFBFC]">
                  <FaBullhorn className="text-[#39C4DC] text-xl" />
                </div>
                <h3 className="text-xl font-semibold mb-2">
                  High-Quality Verified Emails
                </h3>
                <p className="text-gray-600 mb-4">
                  With Exact Mails, you get 1,000 verified emails with a 97%+
                  deliverability rate. Plus, catch-all emails are included at no
                  extra cost.
                </p>
              </div>
            </div>

            <div
              className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left"
              style={{
                backgroundImage: `url(${card2Bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-white opacity-5"></div>
              <div className="relative z-10 flex flex-col h-full">
                <div className="my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 border-[#F9AFBB] border bg-[#FDEBED]">
                  <FaProjectDiagram className="text-[#F88DA0] text-xl" />
                </div>
                <h3 className="text-xl font-semibold mb-2">
                  Low-Quality Email Lists
                </h3>
                <p className="text-gray-600 mb-4">
                  With {formattedTopic}, you get 500 mixed-quality emails,
                  leading to poor deliverability and higher bounce rates.
                </p>
              </div>
            </div>
          </div>
        );
    }
  };

  const sections = [
    {
      number: 1,
      title1: "The",
      title2: "Accuracy",
      title3: "Gap",
      description: (
        <div>
          <div className="w-full">
            {getDescriptionForAdditionalInsights(topic)}
          </div>
          <div className="mt-10">
            <div className="overflow-x-auto w-full">
              <div className="overflow-hidden border border-gray-300 rounded-lg">
                <table className="w-full text-left border-collapse">
                  <thead className="bg-gray-100 text-gray-700">
                    <tr>
                      <th className="py-3 px-6 font-semibold text-left border-b border-gray-300 text-gray-600 rounded-tl-lg">
                        Metric
                      </th>
                      <th className="py-3 px-6 text-center font-semibold border-b border-gray-300 text-green-600">
                        Exact Mails
                      </th>
                      <th className="py-3 px-6 text-center font-semibold border-b border-gray-300 text-red-600 rounded-tr-lg">
                        {formattedTopic}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="hover:bg-gray-50 transition duration-200">
                      <td className="py-3 px-6 text-gray-800 border-b border-gray-300">
                        Fully Verified 98%
                      </td>
                      <td className="py-3 px-6 text-center font-bold text-green-600 border-b border-gray-300 bg-[#F0F9FF]">
                        <div className="flex items-center justify-center">
                          <CheckCircle className="mr-2 text-green-600 w-5 h-5" />
                          1,239
                        </div>
                      </td>
                      <td className="py-3 px-6 text-center font-bold text-red-600 border-b border-gray-300">
                        <div className="flex items-center justify-center">
                          <AlertTriangle className="-ml-3 mr-2.5 text-red-600 w-5 h-5" />
                          865
                        </div>
                      </td>
                    </tr>
                    <tr className="hover:bg-gray-50 transition duration-200">
                      <td className="py-3 px-6 text-gray-800 border-b border-gray-300">
                        Partially Verified 75%
                      </td>
                      <td className="py-3 px-6 text-center font-bold text-green-600 border-b border-gray-300 bg-[#F0F9FF]">
                        <div className="flex items-center justify-center">
                          <PieChart className="-ml-3 mr-2.5 text-green-600 w-5 h-5" />
                          861
                        </div>
                      </td>
                      <td className="py-3 px-6 text-center font-bold text-red-600 border-b border-gray-300">
                        <div className="flex items-center justify-center">
                          <AlertTriangle className="-ml-3 mr-2.5 text-red-600 w-5 h-5" />
                          561
                        </div>
                      </td>
                    </tr>
                    <tr className="hover:bg-gray-50 transition duration-200">
                      <td className="py-3 px-6 text-gray-800 border-b border-gray-300">
                        Total emails found
                      </td>
                      <td className="py-3 px-6 text-center font-bold text-green-600 border-b border-gray-300 bg-[#F0F9FF]">
                        <div className="flex items-center justify-center">
                          <FileText className="mr-2 text-green-600 w-5 h-5" />
                          2,100
                        </div>
                      </td>
                      <td className="py-3 px-6 text-center font-bold text-red-600 border-b border-gray-300">
                        <div className="flex items-center justify-center">
                          <FileText className="mr-2 text-red-600 w-5 h-5" />
                          1,426
                        </div>
                      </td>
                    </tr>
                    <tr className="hover:bg-gray-50 transition duration-200">
                      <td className="py-3 px-6 text-gray-800 border-b border-gray-300 rounded-bl-lg">
                        Credits Deducted
                      </td>
                      <td className="py-3 px-6 text-center font-bold text-green-600 border-b border-gray-300 bg-[#F0F9FF]">
                        <div className="flex items-center justify-center">
                          <CreditCard className="mr-2 text-green-600 w-5 h-5" />
                          1,239
                        </div>
                      </td>
                      <td className="py-3 px-6 text-center font-bold text-red-600 rounded-br-lg border-b border-gray-300">
                        <div className="flex items-center justify-center">
                          <CreditCard className="mr-2 text-red-600 w-5 h-5" />
                          1,426
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <p className="mt-3 font-medium">
              *Finds 51% more valid emails per search.
            </p>
          </div>
        </div>
      ),
    },
    {
      number: 2,
      title1: "You Only Pay for",
      title2: "What Works.",
      title3: "",
      description: (
        <div>
          <div className="w-full">{getDescriptionForEmailQuality(topic)}</div>
          <div className="mt-10">
            <div className="overflow-x-auto w-full">
              <div className="overflow-hidden border border-gray-300 rounded-lg">
                <table className="w-full text-left border-collapse">
                  <thead className="bg-gray-100 text-gray-700">
                    <tr>
                      <th className="py-3 px-6 font-semibold text-left border-b border-gray-300 text-gray-600 rounded-tl-lg"></th>
                      <th className="py-3 px-6 text-center font-semibold border-b border-gray-300 text-green-600">
                        Exact Mails
                      </th>
                      <th className="py-3 px-6 text-center font-semibold border-b border-gray-300 text-red-600 rounded-tr-lg">
                        {formattedTopic}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="hover:bg-gray-50 transition duration-200">
                      <td className="py-3 px-6 text-gray-800 border-b border-gray-300">
                        Pay For:
                      </td>
                      <td className="py-3 px-6 text-center font-bold text-green-600 border-b border-gray-300 bg-[#F0F9FF]">
                        <div className="flex items-center justify-center">
                          <CheckCircle className="-ml-2 mr-2.5 text-green-600 w-5 h-5" />
                          Verified emails only
                        </div>
                      </td>
                      <td className="py-3 px-6 text-center font-bold text-red-600 border-b border-gray-300">
                        <div className="flex items-center justify-center">
                          <AlertTriangle className="-ml-2 mr-2.5 text-red-600 w-5 h-5" />
                          Mixed-quality
                        </div>
                      </td>
                    </tr>
                    <tr className="hover:bg-gray-50 transition duration-200">
                      <td className="py-3 px-6 text-gray-800 border-b border-gray-300">
                        Invalid Emails:
                      </td>
                      <td className="py-3 px-6 text-center font-bold text-green-600 border-b border-gray-300 bg-[#F0F9FF]">
                        <div className="flex items-center justify-center">
                          <PieChart className="mr-2 text-green-600 w-5 h-5" />
                          FREE
                        </div>
                      </td>
                      <td className="py-3 px-6 text-center font-bold text-red-600 border-b border-gray-300">
                        <div className="flex items-center justify-center">
                          <AlertTriangle className="mr-2 text-red-600 w-5 h-5" />
                          Charged
                        </div>
                      </td>
                    </tr>
                    <tr className="hover:bg-gray-50 transition duration-200">
                      <td className="py-3 px-6 text-gray-800 border-b border-gray-300">
                        Duplicates:
                      </td>
                      <td className="py-3 px-6 text-center font-bold text-green-600 border-b border-gray-300 bg-[#F0F9FF]">
                        <div className="flex items-center justify-center">
                          <FileText className="mr-2 text-green-600 w-5 h-5" />
                          Free for 1 year
                        </div>
                      </td>
                      <td className="py-3 px-6 text-center font-bold text-red-600 border-b border-gray-300">
                        <div className="flex items-center justify-center">
                          <FileText className="-ml-2 mr-2.5 text-red-600 w-5 h-5" />
                          Free for 1 year
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <p className="mt-3 font-medium">
            *Why it matters: Anymail Finder’s lower accuracy risks your sender
            reputation.
          </p>
        </div>
      ),
    },
    {
      number: 3,
      title1: "Efficient Bulk",
      title2: "Processing",
      description: (
        <div>
          <div className="mt-10">
            <div className="overflow-x-auto w-full">
              <div className="overflow-hidden border border-gray-300 rounded-lg">
                <table className="w-full text-left border-collapse">
                  <thead className="bg-gray-100 text-gray-700">
                    <tr>
                      <th className="py-3 px-6 font-semibold text-left border-b border-gray-300 text-gray-600 rounded-tl-lg"></th>
                      <th className="py-3 px-6 text-center font-semibold border-b border-gray-300 text-green-600">
                        Exact Mails
                      </th>
                      <th className="py-3 px-6 text-center font-semibold border-b border-gray-300 text-red-600 rounded-tr-lg">
                        {formattedTopic}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="hover:bg-gray-50 transition duration-200">
                      <td className="py-3 px-6 text-gray-800 border-b border-gray-300">
                        Max file size
                      </td>
                      <td className="py-3 px-6 text-center font-bold text-green-600 border-b border-gray-300 bg-[#F0F9FF]">
                        <div className="flex items-center justify-center">
                          <FileCheck className="-ml-4 mr-2.5 text-green-600 w-5 h-5" />
                          150k rows
                        </div>
                      </td>
                      <td className="py-3 px-6 text-center font-bold text-red-600 border-b border-gray-300">
                        <div className="flex items-center justify-center">
                          <FileX className="-ml-3 mr-2.5 text-red-600 w-5 h-5" />
                          25k rows
                        </div>
                      </td>
                    </tr>
                    <tr className="hover:bg-gray-50 transition duration-200">
                      <td className="py-3 px-6 text-gray-800 border-b border-gray-300">
                        Supported formats
                      </td>
                      <td className="py-3 px-6 text-center font-bold text-green-600 border-b border-gray-300 bg-[#F0F9FF]">
                        <div className="flex items-center justify-center">
                          <FileText className="mr-2 text-green-600 w-5 h-5" />
                          CSV & Excel
                        </div>
                      </td>
                      <td className="py-3 px-6 text-center font-bold text-red-600 border-b border-gray-300">
                        <div className="flex items-center justify-center">
                          <FileText className="-ml-2 mr-2.5 text-red-600 w-5 h-5" />
                          Only CSV
                        </div>
                      </td>
                    </tr>
                    <tr className="hover:bg-gray-50 transition duration-200">
                      <td className="py-3 px-6 text-gray-800 border-b border-gray-300 rounded-bl-lg">
                        API Bulk Support
                      </td>
                      <td className="py-3 px-6 text-center font-bold text-green-600 border-b border-gray-300 bg-[#F0F9FF]">
                        <div className="flex items-center justify-center">
                          <CreditCard className="-ml-[60px] mr-2.5 text-green-600 w-5 h-5" />
                          YES
                        </div>
                      </td>
                      <td className="py-3 px-6 text-center font-bold text-red-600 rounded-br-lg border-b border-gray-300">
                        <div className="flex items-center justify-center">
                          <CreditCard className="-ml-14 mr-2.5 text-red-600 w-5 h-5" />
                          NO
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <p className="mt-3 font-medium">
              *Why it matters: Anymail Finder’s lower accuracy risks your sender
              reputation.
            </p>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col bg-white lg:mx-10 mx-6 my-6 overflow-hidden">
      {sections.map((section) => (
        <div key={section.number} className="p-8 mb-6 rounded-lg">
          <div className="px-5 pt-10 text-center">
            <div className="flex justify-center w-full mt-2 lg:mt-6">
              <h2 className="text-3xl sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold">
                {section.title1}{" "}
                <span className="relative inline-block">
                  {section.title2}{" "}
                  <img
                    src={Line}
                    alt="Underline decoration"
                    className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
                  />
                </span>{" "}
                {section.title3}
              </h2>
            </div>
          </div>
          <div className="mt-4 text-gray-700 text-lg leading-relaxed">
            {section.description}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ThreeSections;
